import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { MenuSection } from "./components/MenuSection";
import { Reviews } from "./components/Reviews";
import { Gallery } from "./components/Gallery";
import { Booking } from "./components/Booking";
import { MapSection } from "./components/MapSection";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { MenuFloat } from "./components/MenuFloat";

const Home = () => {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <MenuSection />
        <Reviews />
        <Gallery />
        <Booking />
        <MapSection />
      </main>
      <Footer />
      <WhatsAppFloat />
      <MenuFloat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
